// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3hB7K","label":"Category_label__1CW7e","content":"Category_content__8J26l","header":"Category_header__2ZvkI","location":"Category_location__1hOfJ"};